import { Printer, WebUSB } from "escpos-buffer";
import {
  authoriseFakePrinter,
  FakePrinter,
  fakePrinterAuthorised,
  fakePrinterEnabled,
} from "./fake-printer";

const COMMUNICATIONS_AND_CDC_CLASS = 2; // Used by the E-POS TEP-220MC
const PRINTER_CLASS = 7; // Used by Epson TM-T20II

class WebUSBNotSupportedError extends Error {
  constructor() {
    super(
      "This browser cannot support thermal printing. Please use latest Chrome",
    );
  }
}

async function setup(device: USBDevice): Promise<Printer> {
  if (fakePrinterEnabled()) {
    return new FakePrinter(null);
  }
  const connection = new WebUSB(device);
  return Printer.CONNECT("TM-T20", connection);
}

// check for previously attached printer, but don't open it.
export async function havePreviousPrinter(): Promise<boolean> {
  if (!("usb" in navigator)) throw new WebUSBNotSupportedError();
  try {
    if (fakePrinterEnabled()) {
      return fakePrinterAuthorised();
    }
    const [device] = await navigator.usb.getDevices();
    return !!device;
  } catch (_e) {
    return false;
  }
}

// Re-setup previously allowed devices
export async function getPreviousPrinter(): Promise<Printer | null> {
  if (!("usb" in navigator)) throw new WebUSBNotSupportedError();
  if (fakePrinterEnabled()) {
    if (fakePrinterAuthorised()) {
      const res = await setup(null);
      return res;
    }
    return null;
  }
  const [device] = await navigator.usb.getDevices();
  if (!device) return null;
  const res = await setup(device);
  return res;
}

// Request permission first time
export async function authorisePrinter(): Promise<Printer> {
  if (!("usb" in navigator)) throw new WebUSBNotSupportedError();

  if (fakePrinterEnabled()) {
    authoriseFakePrinter();
    const res = await setup(null);
    return res;
  }
  const device = await navigator.usb.requestDevice({
    filters: [
      { classCode: PRINTER_CLASS },
      { classCode: COMMUNICATIONS_AND_CDC_CLASS },
    ],
  });
  const res = await setup(device);
  return res;
}
